import Const from 'constants';
import {LineupDetails} from 'components/organisms/lineup/components/desktop/lineup-details';
import {
    LineupDetails as MlbTiersLineupDetails,
    LineupDetails as NhlTiersLineupDetails,
    LineupDetails as NbaTiersLineupDetails,
} from 'components/organisms/lineup/components/desktop/lineup-details/game-types/tiers';
import {LineupDetails as NflTiersLineupDetails} from 'components/organisms/lineup/components/desktop/lineup-details/sports/nfl/tiers';
import {LineupDetails as NhlShowDownLineupDetails} from 'components/organisms/lineup/components/desktop/lineup-details/sports/nhl/showdown';
// import {LineupDetails as CfbClassicLineupDetails} from 'components/organisms/lineup/components/desktop/lineup-details/sports/cfb/classic';
import {LineupDetails as CfbShowDownLineupDetails} from 'components/organisms/lineup/components/desktop/lineup-details/game-types/showdown';
import {LineupDetails as CfbSingleGameLineupDetails} from 'components/organisms/lineup/components/desktop/lineup-details/game-types/single-game';
import {LineupDetails as GolfTiersLineupDetails} from 'components/organisms/lineup/components/desktop/lineup-details/sports/golf/tiers';
import {LineupDetails as LolClassicLineupDetails} from 'components/organisms/lineup/components/desktop/lineup-details/sports/lol/classic';
import {LineupDetails as F1ClassicLineupDetails} from 'components/organisms/lineup/components/desktop/lineup-details/sports/f1/classic';

const classesMap = {
    [Const.LEAGUE_CFB]: {
        [Const.GAME_TYPE_CLASSIC]: LineupDetails,
        [Const.GAME_TYPE_SHOWDOWN]: CfbShowDownLineupDetails,
        [Const.GAME_TYPE_SINGLEGAME]: CfbSingleGameLineupDetails,
    },
    [Const.LEAGUE_F1]: {
        [Const.GAME_TYPE_CLASSIC]: F1ClassicLineupDetails,
    },
    [Const.LEAGUE_GOLF]: {
        [Const.GAME_TYPE_CLASSIC]: LineupDetails,
        [Const.GAME_TYPE_SHOWDOWN]: LineupDetails,
        [Const.GAME_TYPE_TIERS]: GolfTiersLineupDetails,
    },
    [Const.LEAGUE_LOL]: {
        [Const.GAME_TYPE_CLASSIC]: LolClassicLineupDetails,
    },
    [Const.LEAGUE_MMA]: {
        [Const.GAME_TYPE_CLASSIC]: LineupDetails,
        [Const.GAME_TYPE_SHOWDOWN]: LineupDetails,
    },
    [Const.LEAGUE_MLB]: {
        [Const.GAME_TYPE_CLASSIC]: LineupDetails,
        [Const.GAME_TYPE_SHOWDOWN]: LineupDetails,
        [Const.GAME_TYPE_SINGLEGAME]: LineupDetails,
        [Const.GAME_TYPE_TIERS]: MlbTiersLineupDetails,
    },
    [Const.LEAGUE_NASCAR]: {
        [Const.GAME_TYPE_CLASSIC]: LineupDetails,
    },
    [Const.LEAGUE_NBA]: {
        [Const.GAME_TYPE_CLASSIC]: LineupDetails,
        [Const.GAME_TYPE_SHOWDOWN]: LineupDetails,
        [Const.GAME_TYPE_SINGLEGAME]: LineupDetails,
        [Const.GAME_TYPE_TIERS]: NbaTiersLineupDetails,
    },
    [Const.LEAGUE_NFL]: {
        [Const.GAME_TYPE_CLASSIC]: LineupDetails,
        [Const.GAME_TYPE_SHOWDOWN]: LineupDetails,
        [Const.GAME_TYPE_SINGLEGAME]: LineupDetails,
        [Const.GAME_TYPE_TIERS]: NflTiersLineupDetails,
    },
    [Const.LEAGUE_NHL]: {
        [Const.GAME_TYPE_CLASSIC]: LineupDetails,
        [Const.GAME_TYPE_SHOWDOWN]: NhlShowDownLineupDetails,
        [Const.GAME_TYPE_SINGLEGAME]: NhlShowDownLineupDetails,
        [Const.GAME_TYPE_TIERS]: NhlTiersLineupDetails,
    },
    [Const.LEAGUE_TENNIS]: {
        [Const.GAME_TYPE_CLASSIC]: LolClassicLineupDetails,
    },
};

const Factory = {
    getComponent(sportConfig) {
        const sportName = sportConfig.getSport().toLowerCase();
        const gameType = sportConfig.getGameType().toLowerCase();

        const componentClass = classesMap[sportName]?.[gameType] ?? null;

        if (componentClass === null) {
            throw new Error(`Unsupported factory for "${sportName}", "${gameType}".`);
        }

        return componentClass;
    },
};

export {Factory};
